module.exports = __webpack_public_path__ + "img/collar_edges_length.adf77948.png";